module.exports = __webpack_public_path__ + "img/RedBullPatternWing.4f158020.svg";